module.exports = __webpack_public_path__ + "static/media/mug_whaleshark.0079e385.webp";